import { money } from "../../utilities/currency";

/** Dansk (Danish) */
const da = {
  home: {
    offer: "✨ Specialtilbud – Betal 99 kr, få 198 kr i opkaldskredit! ✨",
    signIn: "Log ind",
    join: "Bliv medlem",
    allAdvisors: "Alle vejledere",
    festivalTitle: "Festivalkampagner",
    referTitle: "Få din første konsultation gratis!",
    referBody:
      "Book et 15-minutters gratis opkald. Perfekt til at finde den rette rådgiver – sikkert, digitalt og uden forpligtelser.",
    blogTitle: "Fra Mystic-bloggen",
    viewAll: "Se alle",
    subscribeLine: "Få nye guider og tilbud på e-mail.",
    read: "Læs",
    invite: "Book gratis konsultation",
    sponsored: "Sponsoreret",
    ad: (n) => `Annonce ${n}`,
    adBlurb: "Annoncér produkter, apps eller arrangementer her.",
    learnMore: "Læs mere",
    connectNow: "Forbind nu",
    from: "fra",
    minutes: "min",
    verified: "Verificeret",
    categories: [
      "Kærlighedsreading",
      "Clairvoyant reading",
      "Tarot-reading",
      "Astrologi & Horoskop",
      "Englebudskaber",
      "Orakel-vejledning",
      "Drømmetydning",
      "Åndeligt medium",
    ],
    hero: {
      name: "Vejlederne",
      tag: "Kærlighedsekspert",
      blurb:
        "Mit løfte: Jeg er her for dig. Når det er svært at vide, hvem man kan stole på, er ægte nærvær alt.",
      getReading: "Book konsultation",
    },
    footer: {
      getApp: "Få appen for klarhed, uanset hvor du er.",
      explore: "Udforsk",
      special: "Specialer",
      more: "Mere",
      advisors: "Vejledere",
      blog: "Vores blog",
      applyCode: "Brug kampagnekode",
      support: "Kundesupport",
      about: "Om os",
      apply: "Vejleder? Ansøg her",
      privacy: "Privatliv",
      terms: "Vilkår",
    },
    wallet: {
      title: "Køb opkaldsminutter",
      intro:
        "Minutter gemmes i din Mystic-wallet og kan bruges hos alle vejledere (chat / opkald / video).",
      numLabel: "Telefonnummeret du ringer fra",
      amount: "Vælg beløb",
      buy: (amt) => `Køb ${money(amt)} kredit`,
      learn: "Læs mere om betalingsmetoder",
      err: "Indtast et gyldigt telefonnummer",
      otp: (n) => `Kode sendt til ${n}. Indtast den for at bekræfte.`,
      enterOtp: "Indtast kode",
      verify: "Bekræft & tilføj kredit",
      cancel: "Annuller",
      success: (amt) => `${money(amt)} tilføjet til din wallet!`,
      pm1: "Vipps MobilePay",
      pm2: "Kort (kræver registrering på dit mobilnummer)",
      nolgin: "Ingen login nødvendig for Vipps MobilePay – ring direkte.",
    },
  },

  header: {
    hello: "Hej",
    logout: "Log ud",
    login: "Log ind",
  },

  footer: {
    categories: [
      "Dummy 1",
      "Dummy 2",
      "Dummy 3",
      "Dummy 4",
      "Dummy 5",
      "Dummy 6",
      "Dummy 7",
      "Dummy 8",
    ],
    paymentMethods: "Betalingsmetoder",
    footer: {
      getApp: "Få appen for klarhed, uanset hvor du er.",
      explore: "Udforsk",
      special: "Specialer",
      more: "Mere",
      advisors: "Vejledere",
      blog: "Vores blog",
      applyCode: "Brug kampagnekode",
      support: "Kundesupport",
      about: "Om os",
      apply: "Vejleder? Ansøg her",
      privacy: "Privatliv",
      terms: "Vilkår",
    },
  },
};

export default da;
